import ModuleCard from './ModuleCard';

export default ModuleCard;
export * from './ModuleCard';
